// Single source of truth for Daily Specials.
// Used by both `/daily-specials` and the homepage "Today's Special" banner.
// `day` matches JS Date.getDay() (0=Sun ... 6=Sat); use `null` for the
// week-long "Everyday" entry.
export const SPECIALS = [
  {
    key: "tue",
    day: 2,
    label: "Tuesday",
    title: "Add A Cookie Pie for $5 With Any In-Store Purchase",
    blurb: "Grab any Cookie Pie for just $5 when you make any purchase in store — Tuesdays only.",
  },
  {
    key: "wed",
    day: 3,
    label: "Wednesday",
    title: "Build Your Own Waffle — $10",
    blurb: "Design your dream waffle for a flat $10 (max value $16). Add your toppings, your sauces, your way.",
  },
  {
    key: "thu",
    day: 4,
    label: "Thursday",
    title: "Milkshake & Cookie Pie — $10",
    blurb: "Any milkshake paired with any Cookie Pie for just $10. The perfect after-work treat.",
  },
  {
    key: "fri",
    day: 5,
    label: "Friday",
    title: "Add A Milkshake To Any Purchase for $6",
    blurb: "Kick off the weekend right — add any milkshake to your order for just $6 on Fridays.",
  },
  {
    key: "sat",
    day: 6,
    label: "Saturday",
    title: "Add A Loaded Cookie To Your Purchase For Only $3",
    blurb: "Every Saturday — treat yourself to a Loaded Cookie for just $3 when you add it to any purchase.",
  },
  {
    key: "sun",
    day: 0,
    label: "Sunday",
    title: "Cold Cabinet 50% Off · 6–9pm",
    blurb: "From 6pm til close, every item in the cold cabinet drops to half price. First in, best dressed.",
  },
  {
    key: "everyday",
    day: null,
    label: "Everyday",
    title: "Student & SuperGold Discounts",
    blurb: "10% off your purchase with a valid current Student ID, and 20% off for SuperGold card holders. Available in-store, every day we're open.",
  },
];

export const getTodaysSpecial = () => {
  const today = new Date().getDay();
  return SPECIALS.find((s) => s.day === today) || null;
};

export const getEverydaySpecial = () => SPECIALS.find((s) => s.day === null) || null;
